import { IStore } from "../store"

import initMenuData from "./init-menu-data"

export default function init(store: IStore) {
  initMenuData(store)
}
